import { Component, OnInit, Input, Output, EventEmitter } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { ObtenerUsuarioPorCargoService } from "../../servicios/obtener-usuario-por-cargo.service";
import { ActivatedRoute } from "@angular/router";
import { MuestraMensaje } from "../../shared/utilerias/notificaciones/notificaciones.component";
import { ObtenerUsuarioPorCargo, CatCargos, CatEstatus, ObtenerUsuarioPorCargoInput } from '../../entidades/entidades';
import { CatCargosService } from '../../servicios/cat-cargos.service';
import { CatEstatusService } from '../../servicios/cat-estatus.service';




@Component({
  selector: "app-obtener-usuario-por-cargo",
  templateUrl: "./obtener-usuario-por-cargo.component.html",
  styleUrls: ["./obtener-usuario-por-cargo.component.css"]
})

export class ObtenerUsuarioPorCargoComponent implements OnInit {
  muestraMensaje = new MuestraMensaje();
  obtenerUsuarioPorCargoForm: FormGroup;
  catalogosForm: FormGroup;
  @Input("obtenerUsuarioPorCargo") obtenerUsuarioPorCargo: ObtenerUsuarioPorCargo;
  @Output("obtenerUsuarioPorCargoOutput") obtenerUsuarioPorCargoOutput: EventEmitter<ObtenerUsuarioPorCargo>;
  public usuarioPorCargo = new ObtenerUsuarioPorCargoInput();
  public catCargos: CatCargos [] = [];
  public cCargo: CatCargos;

  public catEstatus: CatEstatus [] = [];
  public cEstatus: CatEstatus;

  public usuarioD:  ObtenerUsuarioPorCargo [] = [];
  public usuarioS:  ObtenerUsuarioPorCargo [] = [];

  constructor(
    private formBuilder: FormBuilder,
    private obtenerUsuarioPorCargoService: ObtenerUsuarioPorCargoService,
    private catCargosService: CatCargosService,
    private catEstatusService: CatEstatusService,
    private route: ActivatedRoute,
  ) {
    this.obtenerUsuarioPorCargoOutput = new EventEmitter()
  }

  ngOnInit() {
    this.obtenerUsuarioPorCargoForm = this.formBuilder.group({
      id : [undefined  ],
      nombre : [undefined  ],
      nombreUsuario : [undefined  ],
      cargo : [undefined  ],
      departamento : [undefined  ],
      direccion : [undefined  ],
      estatus : [undefined],
    });
    // if (this.obtenerUsuarioPorCargo) this.obtenerUsuarioPorCargoForm.patchValue(this.obtenerUsuarioPorCargo);

    this.getCatCargos();
    this.getCatEstatus();
  }


  // ====================================================
  // Metodos para obtener datos del servicio
  // ====================================================
  async addObtenerUsuarioPorCargo() {
    try {
     await this.limpia();
     if (this.cCargo) {
      this.usuarioPorCargo.idCargo = this.cCargo.id;
     } else {
       this.usuarioPorCargo.idCargo = this.catCargos[0].id;
     }

     if(this.cEstatus) {
      this.usuarioPorCargo.idEstatus = this.cEstatus.id;
     } else {
      this.usuarioPorCargo.idEstatus = this.catEstatus[0].id;
     }
      console.log('Busqueda', this.usuarioPorCargo);
      const datoretorno = await this.obtenerUsuarioPorCargoService
        .add(this.usuarioPorCargo)
        .toPromise();
      this.obtenerUsuarioPorCargo = datoretorno;
      console.log('USUARIOS:', datoretorno);
      this.usuarioD.push(datoretorno);
      // this.obtenerUsuarioPorCargoForm.patchValue(this.obtenerUsuarioPorCargo);
    } catch (e) {
      if (e.response) throw { message: e.response.data };
      else throw e;
    } finally {
      console.log("Paso por addObtenerUsuarioPorCargo");
    }
  }

  async limpia () {
    this.usuarioD = [];
  }


  async getAllObtenerUsuarioPorCargo() {
    try {
      await this.limpia();
      this.usuarioPorCargo.idCargo = null;
      this.usuarioPorCargo.idEstatus = null;
      console.log('Busqueda', this.usuarioPorCargo);
      const datoretorno = await this.obtenerUsuarioPorCargoService
        .add(this.usuarioPorCargo)
        .toPromise();
      this.obtenerUsuarioPorCargo = datoretorno;
      console.log('USUARIOS:', datoretorno);
      this.usuarioD.push(datoretorno);
    } catch (e) {
      if (e.response) throw { message: e.response.data };
      else throw e;
    } finally {
      console.log("Paso por getAllObtenerUsuarioPorCargo");
    }
  }

  async getCatCargos() {
    const datoRetorno = await this.catCargosService.getAll().toPromise();
    this.catCargos = datoRetorno;
    console.log('Cargos: ', this.catCargos);
  }

  async getCatEstatus() {
    const datoRetorno = await this.catEstatusService.getAll().toPromise();
    this.catEstatus = datoRetorno;
    console.log('Estatus: ', this.catEstatus);
  }
}